<template>
  <div id="page-user-list">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <div class="vx-col w-1/2">
        <h2 class="breadcrumb">Προϊόντα</h2>
      </div>

      <div class="vx-col w-1/2">
        <div class="flex flex-wrap" style="justify-content: end !important;">
          <vs-button @click="generateXls" color="primary" type="border" icon="cloud_download" class="mb-2">
            Εξαγωγή προϊόντων
          </vs-button>
          <vs-button @click="importProductsFromXLS" color="primary" type="border" icon="cloud_upload" class="mb-2 ml-1">
            Εισαγωγή προϊόντων
          </vs-button>
          <vs-button @click="goToNewProduct" color="primary" type="filled" icon="add" class="ml-1 mb-2">
            Προσθήκη
          </vs-button>
        </div>
      </div>
    </vs-row>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                  @input="updateSearchQuery" placeholder="Αναζήτηση..."/>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="recordsData['products']" rowSelection="multiple" colResizeDefault="shift"
                   :animateRows="true"
                   :excelStyles="excelStyles"
                   :floatingFilter="true" :pagination="true" :cacheBlockSize="10"
                   :paginationPageSize="paginationPageSize"
                   @rowDoubleClicked="editItem"
                   :paginationAutoPageSize="true" :filter="true">
      </ag-grid-vue>
    </div>
  </div>

</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import CellRendererLink from './cell-renderer-products/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer-products/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer-products/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer-products/CellRendererActions.vue'
import axios from '@/axios'

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      item: {
        checked: '',
        skroutz: '',
        part_number: '',
        name: '',
        erp_price: '',
        promo_price: '',
        categoryId: null,
      },
      searchQuery: '',
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        pagination: true,
        animateRows: true,
        resizable: true,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: false,
      },
      excelStyles: [
        {
          id: 'string',
          dataType: 'string',
        },
      ],
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 125,
          filter: 'agTextColumnFilter',
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          hide: false
        },
        {
          headerName: 'Έλεγχος',
          field: 'checked',
          filter: 'agTextColumnFilter',
          width: 160,
          cellRendererFramework: 'CellRendererStatus',
        },
        {
          headerName: 'UID',
          field: 'remoteId',
          filter: 'agTextColumnFilter',
          width: 160,
          cellStyle: { dataType: 'string' },
          cellClass: 'string'  // Add this line
        },
        {
          headerName: 'MPN',
          field: 'part_number',
          filter: 'agTextColumnFilter',
          width: 150,
          cellStyle: { dataType: 'string' },
          cellClass: 'string'  // Add this line
        },
        {
          headerName: 'Όνομα Προϊόντος',
          field: 'name',
          filter: 'agTextColumnFilter',
          flex: 1,
          minWidth: 300,
        },
        {
          headerName: 'Κατηγορία',
          field: 'category.name',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Υποκατηγορία',
          field: 'group',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Κατασκευαστής',
          field: 'manufacturer',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Τιμή',
          field: 'erp_price',
          filter: 'agTextColumnFilter',
          width: 150,
          cellStyle: {'text-align': 'right'},
          valueFormatter: (params) => {
            if (params && params.data && params.data.erp_price) {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.erp_price);
            }
          },
        },
        {
          headerName: 'Τιμή με Έκπτωση',
          field: 'promo_price',
          filter: 'agTextColumnFilter',
          width: 150,
          cellStyle: {'text-align': 'right'},
          valueFormatter: (params) => {
            if (params && params.data && params.data.promo_price) {
              return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(params.data.promo_price);
            } else {
              return 0;
            }
          },
        },
        {
          headerName: 'Η/Μ Δημιουργίας',
          field: 'created_at',
          filter: 'agTextColumnFilter',
          width: 200,
          valueFormatter: (params) => {
            if (!params.value) return '';
            const date = new Date(params.value);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
          },
        },
        {
          headerName: '',
          field: 'id',
          width: 120,
          cellRendererFramework: 'CellRendererActions',
          pinned: 'right',
          suppressNavigable: true,
          cellClass: 'no-border',
          filter: false,
        },
      ],
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    }
  },
  watch: {
    recordsData: {
      deep: true,
      handler(newData) {
        // Update grid when data changes
        if (this.gridApi && newData && newData.products) {
          this.$nextTick(() => {
            this.gridApi.setRowData(newData.products)
          })
        }
      }
    },
    roleFilter(obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter(obj) {
      this.setColumnFilter('status', obj.value)
    },
    isVerifiedFilter(obj) {
      const val =
          obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
      this.setColumnFilter('is_verified', val)
    },
    departmentFilter(obj) {
      this.setColumnFilter('department', obj.value)
    },
  },
  computed: {
    recordsData() {
      return this.$store.getters.getProducts
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
    message: {
      get() {
        return this.$store.state.obj.message
      },
      set(value) {
        this.$store.commit('updateMessage', value)
      },
    },
  },
  methods: {
    generateXls() {
      let vm = this
      vm.$vs.loading()
      axios.get('products/generate-xls', {
        headers: {
          'Accept': 'application/vnd.ms-excel'
        },
        responseType: 'arraybuffer'
      })
      .then((response) => {
        vm.$vs.loading.close()
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'products.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch((error) => {
        vm.$vs.loading.close()
      })
    },
    importProductsFromXLS() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Επιβεβαίωση`,
        text: 'Θα μεταφερθείτε σε περιβάλλον εισαγωγή νέων προϊόντων και συνδέσμων από excel. Είστε σίγουροι;',
        acceptText: 'Άνοιγμα',
        cancelText: 'Ακύρωση',
        accept: this.importProductsnLinksAction
      })
    },
    importProductsnLinksAction() {
      window.location.href = "/settings/sync-xls";
    },
    goToNewProduct() {
      this.$store.dispatch('setProductPageCation', 'Νέα εγγραφή')
      this.$router.push('/products/edit')
      // Set product to an empty object
      const product = {
        part_number: '',
        checked: false,
        name: '',
        manufacturer: '',
        erp_price: 0,
        promo_price: 0,
        categoryId: null,
      }
      this.$store.dispatch('setProduct', product)
    },
    editItem(item) {
      this.$router.push("/products/edit/" + item.data.id)
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter =
          this.statusFilter =
              this.isVerifiedFilter =
                  this.departmentFilter =
                      {
                        label: 'All',
                        value: 'all',
                      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    updateProducts() {
      this.$vs.dialog({
        color: 'primary',
        title: `Ενημέρωση των προϊόντων`,
        text: `Θα γίνει ενημέρωση προϊόντων και τιμών από το αρχείο xml. Για αποδοχή της διαδικασίας κάντε κλικ στο
        κουμπί αποδοχή για ακύρωση κάντε κλικ στο Χ. Η διάρκεια της διαδικασίας είναι από 1 έως 3 λεπτά και είναι
        ανάλογη προς το πλήθος των προϊόντων σας`,
        acceptText: 'αποδοχή',
        accept: this.acceptAlert,
      })
    },
    acceptAlert() {
      this.$vs.loading()
      this.$store.dispatch('xmlUpdate').then((response) => {
        if (response.error === false) {
          this.$vs.notify({
            color: 'success',
            title: 'Επιτυχία',
            position: 'top-right',
            text: 'Η ενημέρωση έγινε.',
          })

          this.$store.dispatch('fetchProducts').then(() => {
            this.$vs.loading.close()
          })
          this.$vs.loading.close()
        } else {
          this.$vs.notify({
            color: 'error',
            title: 'Αποτυχία',
            position: 'top-right',
            text: 'Η ενημέρωση δεν έγινε',
          })
          this.$vs.loading.close()
        }
      })
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    // Ensure grid refreshes when data is available
    if (this.recordsData && this.recordsData.products && this.recordsData.products.length > 0) {
      this.$nextTick(() => {
        this.gridApi.setRowData(this.recordsData.products)
      })
    }
  },
  created() {
    this.$vs.loading()
    this.$store.dispatch('fetchProducts').then(() => {
      this.$vs.loading.close()
      // Force grid update after data is loaded
      if (this.gridApi) {
        this.$nextTick(() => {
          this.gridApi.setRowData(this.recordsData.products)
        })
      }
    }).catch(() => {
      this.$vs.loading.close()
    })
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
